<template>
  <div class="mb-4">
    <label class="flex items-center">
      <input
        type="checkbox"
        :checked="modelValue"
        @change="$emit('update:modelValue', $event.target.checked)"
        class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        :class="{ 'border-red-500': error }"
      />
      <span class="ml-2 text-sm text-gray-600" :class="{ 'text-red-500': error }">
        {{ label }}
      </span>
    </label>
    <p v-if="error" class="mt-1 text-sm text-red-600">{{ error }}</p>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    error: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue']
}
</script>
